import { FormikProvider } from 'formik';
import { useMemo, useState } from 'react';

import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useCurrentuser } from '@uplift/contexts';
import { useL10n } from '@uplift/hooks';
import { useSupportRequestTypesQuery } from '@uplift/queries';
import { Button, Select, TextInput } from '@uplift/ui-v2';

import { useSupportRequestFormHook } from './form.hook';
import { SuccessFailAlert } from './success-fail-alert';


const useStyles = makeStyles()(theme => ({
  textArea: {
    '& textarea::placeholder': {
      fontStyle: 'italic'
    }
  },
  input: {
    '& label.Mui-focused:not(.Mui-error)': {
      color: theme.palette.secondary.main,
    },
    '& div.Mui-focused:not(.Mui-error) fieldset': {
      borderColor: `${theme.palette.secondary.main} !important`,
    },
  }
}));

export const SendRequestForm = () => {
  const [ isSubmitSuccess, setSubmitSuccess ] = useState<boolean | null>(null);
  const l10n = useL10n();
  const { classes, cx } = useStyles();
  const me = useCurrentuser();
  const { data: _requestTypes = [] } = useSupportRequestTypesQuery();
  const requestTypes = useMemo(() =>
    _requestTypes
      .filter(t => t.role === me?.role)
      .map(t => ({ value: t.id, label: t.name }))
  , [ _requestTypes, me.role ]);

  const onSuccess = () => {
    setSubmitSuccess(true);
  };

  const onError = () => {
    setSubmitSuccess(false);
  };

  const { formik, isFetching } = useSupportRequestFormHook(onSuccess, onError);

  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit}>
        <Typography variant="h4" color="secondary" style={{ fontWeight: 700 }}>{l10n.support.sendMessage}</Typography>
        <SuccessFailAlert isSubmitSuccess={isSubmitSuccess} />
        <Box mt={4} mb={3}>
          <Select
            label={l10n.support.selectTopic}
            name="supportTopic"
            items={requestTypes}
            className={classes.input}
          />
        </Box>
        <Box mt={3}>
          <TextInput
            className={cx(classes.textArea, classes.input)}
            multiline
            name="supportDetails"
            placeholder={l10n.support.placeholder}
            fullWidth
            label={l10n.support.moreDetails}
            rows={6}
          />
        </Box>
        <Box mt={4} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="secondary"
            type="submit"
            size="large"
            disabled={isFetching}
            loading={isFetching}
          >
            {l10n.general.submit}
          </Button>
        </Box>
      </form>
    </FormikProvider>
  );
};
